<app-loading [showText]="false" [inline]="true" *ngIf="loading"></app-loading>
<ng-container *ngIf="!loading && ! hide">
    <button [class.w-100]="fullWidth" [matBadge]="badge" [class]="'button--solid button--solid--' + color" *ngIf="fill === 'solid' else clear"
            (click)="click($event)"
            [disabled]="disabled" [matTooltip]="disabledAccordingToPermission ? 'Vos permissions ne permettent pas d\'utiliser ce boutton' : tooltip">
        <i-tabler name="{{iconName}}" class="icon-{{iconHeight}} d-flex" *ngIf="iconName"></i-tabler>
        <span class="label" *ngIf="label" [class.w-100]="!iconName" [class.text-center]="!iconName">{{label}}</span>
    </button>
  <ng-template #clear>

      <button [class.w-100]="fullWidth" [class.with-label]="!!label" [matBadge]="badge" (click)="click($event)" [disabled]="disabled" [matTooltip]="disabledAccordingToPermission ? 'Vos permissions ne permettent pas d\'utiliser ce boutton' : tooltip"
              [class]="'button--clear button--color--' + color">
          <i-tabler name="{{iconName}}" class="icon-{{iconHeight}} d-flex" *ngIf="iconName"></i-tabler>
          <span class="label" *ngIf="label">{{label}}</span>
          <ng-content></ng-content>
      </button>
  </ng-template>
</ng-container>
